import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TContractCodeDocumentDM from './TContractCodeDocumentDM'
import TWarehouseDM from './TWarehouseDM'
import TCompanyDividedBookDM from './TCompanyDividedBookDM'
import TK2UserLookupDM from './TK2UserLookupDM'
import TCompanyDM from './TCompanyDM'

export default class TOwnCompaniesJobCardConfigDM extends Data {
	public static className = 'TOwnCompaniesJobCardConfigDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	RejectionLocationId?: number
	WIPLocationId?: number
	ConsumptionLocationId?: number
	FinalLocationId?: number
	IsValid?: string
	ChangedOn?: Date
	RecordNumber?: number
	RID?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	IconCalc?: number
	@Type(() => TContractCodeDocumentDM)
	ContractCodeRID?: TContractCodeDocumentDM
	@Type(() => TWarehouseDM)
	RejectionWarehouseId?: TWarehouseDM
	@Type(() => TWarehouseDM)
	WIPWarehouseId?: TWarehouseDM
	@Type(() => TWarehouseDM)
	ConsumptionWarehouseId?: TWarehouseDM
	@Type(() => TWarehouseDM)
	FinalWarehouseId?: TWarehouseDM
	@Type(() => TCompanyDividedBookDM)
	CompletionJCBookId?: TCompanyDividedBookDM
	@Type(() => TCompanyDividedBookDM)
	PlanningJCBookId?: TCompanyDividedBookDM
	@Type(() => TK2UserLookupDM)
	ChangedById?: TK2UserLookupDM
	@Type(() => TCompanyDM)
	CompanyId?: TCompanyDM
}